export type Anchor = {
  zone: string;
};

export const isAnchorEqual = (a: Anchor, b: Anchor): boolean => {
  return a.zone === b.zone;
};

export type Comment = {
  name: string;
  anchor?: Anchor;
  resolved: boolean;
};
